import React from 'react';
import useEmailCVs from './EmailCVs';
import useAIGenerate from './AIGenerate';
import { usePortalApi } from '../PortalApiContext';

const defaultValue = {
    emailCVs: () => console.error("Not implemented"),
    aiGenerate: () => console.error("Not implemented")
};
const PowerFlowContext = React.createContext();

export function PowerFlowProvider({ children }) {
    const { apiCall, loadingIframe, profileData, loadedIframeLocation } = usePortalApi();
    const emailCVs = useEmailCVs(apiCall);
    const aiGenerate = useAIGenerate(apiCall);
    const value = React.useMemo(() => {       
        if (!loadingIframe && profileData && loadedIframeLocation)  {
            return {
                emailCVs,
                aiGenerate
            };
        } else return defaultValue;
    }, [loadingIframe, profileData, loadedIframeLocation, emailCVs, aiGenerate]);

    return (
        <PowerFlowContext.Provider value={value}>
            {children}
        </PowerFlowContext.Provider>
    );
}

export default function usePowerFlow() {
    return React.useContext(PowerFlowContext);
}